import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SETTINGS } from '../config/common.settings';

@Injectable({
  providedIn: 'root',
})
export class TransferReservationService {
  constructor(private http: HttpClient) {}

  createTransferReservation(payload: any): Observable<any> {
    return this.http.post(
      `${SETTINGS.BASE_API}/transfer-bookings/create`,
      payload,
    );
  }

  getTransferReservationsPaged(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/transfer-bookings/get-paged`, payload)
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
          error: (error: any) => {
            reject(error.error.message);
          },
        });
    });
  }

  updateBooking(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .put(`${SETTINGS.BASE_API}/transfer-bookings/update`, payload)
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
          error: (error: any) => {
            reject(error.error.message);
          },
        });
    });
  }

  getTransferBookingById(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .get(`${SETTINGS.BASE_API}/transfer-bookings/get/${payload}`)
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
          error: (error: any) => {
            reject(error.error.message);
          },
        });
    });
  }
  getAllPagingBoardDataTransfer(payload: any): Observable<any> {
    return this.http.post(
      `${SETTINGS.BASE_API}/transfer-bookings/get-paging`,
      payload,
    );
  }
}
